/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map

document.addEventListener('DOMContentLoaded', function () {
  var stickyBar = document.getElementById('dgStickyAtc');
  var stickyButton = document.getElementById('dgStickyAtcButton');
  var productJsonEl = document.getElementById('dgStickyProductJson');

  if (!stickyBar || !stickyButton || !productJsonEl) return;

  var productData = null;
  try {
    productData = JSON.parse(productJsonEl.textContent);
  } catch (e) {
    return;
  }

  var mainForm =
    document.querySelector('product-form form') ||
    document.querySelector('form[action*="/cart/add"]');

  if (!mainForm) return;

  var mainButton =
    mainForm.querySelector('button[name="add"]') ||
    mainForm.querySelector('[type="submit"]');

  var variantInput = mainForm.querySelector('input[name="id"]');

  var stopZone =
    document.querySelector('.product-recommendations') ||
    document.querySelector('[data-section-type="related-products"]') ||
    document.querySelector('.related-products') ||
    document.querySelector('[id*="recommendation"]') ||
    document.querySelector('[class*="recommendation"]') ||
    document.querySelector('[class*="related"]');

  var atcButtonAbove = false;
  var stopZoneReached = false;

  function getVariant() {
    if (!variantInput || !productData) return null;
    var id = String(variantInput.value);
    return productData.variants.find(function (v) {
      return String(v.id) === id;
    }) || null;
  }

  function syncButton() {
    var variant = getVariant();
    if (!variant) return;
    stickyButton.disabled = !variant.available;
    stickyButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
  }

  function evaluate() {
    if (atcButtonAbove && !stopZoneReached) {
      stickyBar.classList.add('is-visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    } else {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    }
  }

  syncButton();
  evaluate();

  if (mainButton) {
    var atcObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var wentAbove = entry.boundingClientRect.top < 0;
          atcButtonAbove = !entry.isIntersecting && wentAbove;
          evaluate();
        });
      },
      { threshold: 0 }
    );

    atcObserver.observe(mainButton);
  }

  function checkStopZonePosition() {
    if (!stopZone) return;
    var rect = stopZone.getBoundingClientRect();

    // Se o topo dos relacionados já entrou ou passou da viewport,
    // a sticky deve permanecer escondida.
    stopZoneReached = rect.top <= window.innerHeight * 0.9;
    evaluate();
  }

  if (stopZone) {
    checkStopZonePosition();

    window.addEventListener(
      'scroll',
      function () {
        checkStopZonePosition();
      },
      { passive: true }
    );

    window.addEventListener('resize', checkStopZonePosition);
  }

  if (variantInput) {
    new MutationObserver(syncButton).observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
    variantInput.addEventListener('change', syncButton);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('form[action*="/cart/add"]')) {
      setTimeout(syncButton, 100);
    }
  });

  stickyButton.addEventListener('click', function () {
    if (mainButton && !mainButton.disabled) {
      mainButton.click();
    } else if (mainForm) {
      mainForm.requestSubmit();
    }
  });
});